import React from 'react';
import './LandingPage.css'; // Import the custom CSS file
import yourPhoto from '../assets/yourPhoto.png'; // Import your profile photo
import AudioPlayerComponent from './AudioPlayerComponent';
import greetings from '../assets/greetings.mp3'; // Import the demo audio file

const HomePage = () => {
  return (
    <div className="homepage-container">
         <div className="photo-container">
    <img src={yourPhoto} alt="female voice over artist in india- anushka rath" className="profile-photo-l" />
  </div>
      <div className="text-container">
        <h1 className="hello-text">Hello!</h1>
        <h1 className="intro-text">I am Anushka Rath,</h1>
        <h2 className="description-text">female voice artist from India</h2>
        <AudioPlayerComponent
        src={greetings}
        title="My Demo" 
        artist="Anushka Rath/ Demo" />
      </div>
    </div>
   
  );
};

export default HomePage;
